<template>
    <div class="container">
        <el-page-header @back="$router.back()" :content="title"></el-page-header>
        <div class="content">
            <el-descriptions title="报名学员查询"></el-descriptions>
            <el-form :model="form" size="mini" label-width="100px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="班级：" label-width="70px">
                            <el-select v-model="form.ClassId">
                                <el-option label="全部" :value="0"></el-option>
                                <el-option v-for="(item,index) in classList" :key="index" :label="item.ClassName" :value="item.ClassId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="推荐单位：">
                            <el-input v-model="form.MerchantName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="审核状态：">
                            <el-select v-model="form.AuditStatus">
                                <el-option v-for="(item,index) in auditStatus" :key="index" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上次审核：">
                            <el-select v-model="form.LastAuditStatus">
                                <el-option v-for="(item,index) in lastAuditStatus" :key="index" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row type="flex">
                    <el-col :span="6">
                        <el-form-item label="排序：" label-width="70px">
                            <el-select v-model="form.sort">
                                <el-option v-for="(item,index) in sorts" :key="index" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="payType == 2">
                        <el-form-item label="缴费状态：">
                            <el-select v-model="form.payFeeStatus">
                                <el-option v-for="(item,index) in payFeeStatus" :key="index" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" size="mini" style="width: 100px;margin-left: 100px;" @click="getListData(true)">查询</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div class="statistics">
                <p v-if="allCount == 0">没有满足条件的记录</p>
                <p v-else>共有 {{allCount}} 名学员符合查询条件，{{(list.length == allCount) ? '已全部加载' : `已加载前 ${list.length} 名学员`}}。</p>
            </div>
            <el-table
                ref="table"
                style="width: 100%"
                v-loading="loading && !isMore"
                element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                :data="list"
                size="mini"
                border
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="50" v-if="payType == 2"></el-table-column>
                <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>
                <el-table-column label="等级" align="center" prop="ClassName"></el-table-column>
                <el-table-column label="推荐单位" align="center">
                    <template slot-scope="scope">
                        <p style="width: 100%;text-align: left">{{scope.row.MerchantName || '个人'}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="学员缴费状态" align="center" v-if="payType == 2">
                    <template slot-scope="scope">
                        <span style="color: #36b37e;" v-if="scope.row.StudentIsPaid">已缴费</span>
                        <span style="color: #ff5630;" v-else>未缴费</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单支付状态" align="center" v-else>
                    <template slot-scope="scope" v-if="scope.row.PaymentStatus != null">
                        <span :style="{'color': ['#ff5630', '#ff991f', '#36b37e'][scope.row.PaymentStatus]}">{{['未支付', '待确认', '已支付'][scope.row.PaymentStatus]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="姓名" align="center" prop="Name"></el-table-column>
                <el-table-column label="报名时间" align="center">
                    <template slot-scope="scope">{{dateFormat(scope.row.EnrollTime, 'yyyy-MM-dd HH:mm')}}</template>
                </el-table-column>
                <el-table-column label="提交时间" align="center">
                    <template slot-scope="scope">{{dateFormat(scope.row.SubmitTime, 'yyyy-MM-dd HH:mm')}}</template>
                </el-table-column>
                <el-table-column label="审核时间" align="center">
                    <template slot-scope="scope">{{dateFormat(scope.row.AuditTime, 'yyyy-MM-dd HH:mm')}}</template>
                </el-table-column>
                <el-table-column label="审核状态" align="center">
                    <template slot-scope="scope">{{getAuditStatus(scope.row.AuditStatus)}}</template>
                </el-table-column>
                <el-table-column label="上次审核" align="center">
                    <template slot-scope="scope">{{getLastAuditStatus(scope.row)}}</template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button 
                            type="text" 
                            @click="lookDetail(scope.row.EnrollId)"
                        >查看/审核</el-button>
                    </template>
                </el-table-column>
                <div slot="append" class="load_more" v-show="isMore" @click="getListData()">{{loading ? '加载中' : '加载下一页'}}</div>
            </el-table>
            <div style="margin-top: 10px;" v-if="payType == 2">
                <span style="margin-right: 100px;">
                    <el-button size="mini" @click="selection('all')">全部勾选</el-button>
                    <el-button size="mini" @click="selection('clear')">清除勾选</el-button>
                    <el-button size="mini" @click="selection('inverse')">反向勾选</el-button>
                </span>
                <span>
                    <el-button type="success" size="mini" @click="batchPayFee(true)">批量设置为“已缴费”</el-button>
                    <el-button type="danger" size="mini" @click="batchPayFee(false)">批量设置为“未缴费”</el-button>
                </span>
            </div>
        </div>
        <student-dialog ref="studentDialog" :payType="payType" @auditStatusChange="auditStatusChange" @payStatusChange="payStatusChange"></student-dialog>
    </div>
</template>
<script>
import utils from '@/utils';
import studentDialog from '../components/studentDialog.vue';
export default {
    name: 'trainingEnrollAudit',
    components: {
        studentDialog
    },
    data() {
        return {
            trainId: 0,
            payType: 0,
            form: {
                ClassId: 0,
                MerchantName: "",
                AuditStatus: 4,
                LastAuditStatus: null,
                sort: 1,
                payFeeStatus: null
            },
            classList: [],
            auditStatus: [
                {label: '不限', value: null},
                {label: '未提交', value: 0},
                {label: '待审核', value: 1},
                {label: '审核通过', value: 2},
                {label: '审核不通过', value: 3},
                {label: '已提交', value: 4}
            ],
            lastAuditStatus: [
                {label: '不限', value: null},
                {label: '审核通过', value: 2},
                {label: '审核不通过', value: 3},
                {label: '无', value: 4},
                {label: '通过或无', value: 5}
            ],
            sorts: [
                {label: '报名时间，从早到晚', value: 1},
                {label: '报名时间，从晚到早', value: 2},
                {label: '提交时间，从早到晚', value: 3},
                {label: '提交时间，从晚到早', value: 4},
                {label: '审核时间，从早到晚', value: 5},
                {label: '审核时间，从晚到早', value: 6},
            ],
            payFeeStatus: [
                {label: '不限', value: null},
                {label: '未缴费', value: 0},
                {label: '已缴费', value: 1},
            ],
            list: [],
            loading: false,
            allCount: 0,
            isMore: false,
            multipleSelection: []
        };
    },
    created() {
        let trainId = +this.$route.params.id;
        this.trainId = trainId;
        this.payType = +this.$route.query.payType;
        this.getClassList();
        this.getListData(true);
    },
    computed:{
        title(){
            return (this.$route.query.name || '') + '在线报名';
        },
        TimeOrderType(){
            return Math.ceil(this.form.sort / 2);
        },
        TimeOrderIsAsc(){
            return this.form.sort % 2 == 1;
        },
        lastId(){
            let list = this.list,
                len = list.length;
            return len ? list[len - 1].EnrollId : 0;
        }
    },
    methods: {
        dateFormat: utils.dateFormat,
        handleSelectionChange(values){
            this.multipleSelection = values;
        },
        getListData(isReload){
            if(this.loading)return;
            let lastId = this.lastId;
            if(isReload){
                lastId = 0;
                this.isMore = false;
            }
            this.loading = true;
            this.$api.GetTrainEnrollStudentAuditList({
                "TrainId": this.trainId,
                "Continuation": {
                    "LastId": lastId,
                    "MaxCount": 20
                },
                "ClassId": this.form.ClassId,
                "MerchantId": 0,
                "MerchantName": this.form.MerchantName,
                "AuditStatus": this.form.AuditStatus,
                "LastAuditStatus": this.form.LastAuditStatus,
                "TimeOrderType": this.TimeOrderType,
                "TimeOrderIsAsc": this.TimeOrderIsAsc,
                "StudentPayStatus": this.form.payFeeStatus
            }).then(data=>{
                this.loading = false;
                if(data.Code == 0){
                    let continueList = data.ContinueList || [];
                    let list = []
                    if(lastId){
                        list = [...this.list, ...continueList];
                    }else{
                        list = continueList;
                    }
                    this.$set(this, 'list', list);
                    this.allCount = data.AllCount || 0;
                    if(list.length < this.allCount){
                        this.isMore = true;
                    }else{
                        this.isMore = false;
                    }
                }
            }).catch(()=>{
                this.loading = false;
            })
        },
        getClassList(){
            this.$api.GetTrainClasses({
                "TrainId": this.trainId
            }).then(data=>{
                if(data.Code == 0){
                    this.classList = data.TrainClasses || [];
                }
            })
        },
        getAuditStatus(status){
            let obj = this.auditStatus.filter(item=>item.value == status)[0];
            return obj ? obj.label : '';
        },
        getLastAuditStatus(item){
            let {
                AuditStatus,
                LastAuditStatus
            } = item;
            if([2,3].includes(AuditStatus)){
                return "";
            }else if(LastAuditStatus == 2){
                return "审核通过";
            }else if(LastAuditStatus == 3){
                return "审核不通过";
            }else{
                return "";
            }
        },
        selection(type){
            let tableRef = this.$refs.table;
            if(type == 'all'){
                tableRef.toggleAllSelection();
            }else if(type == 'clear'){
                tableRef.clearSelection();
            }else if(type == 'inverse'){
                let list = [...this.list];
                let multipleSelection = [...this.multipleSelection];
                if(multipleSelection.length == list.length){
                    tableRef.clearSelection();
                }else if(multipleSelection.length == 0){
                    tableRef.toggleAllSelection();
                }else{
                    list.forEach(item=>{
                        if(multipleSelection.includes(item)){
                            tableRef.toggleRowSelection(item, false);
                        }else{
                            tableRef.toggleRowSelection(item, true);
                        }
                    })

                }
            }
        },
        batchPayFee(isPayFee){
            let multipleSelection = [...this.multipleSelection];
            if(multipleSelection.length == 0){
                this.$message.warning('请勾选表格中需要操作的行');
            }else{
                let ids = multipleSelection.map(item=>item.EnrollId)
                this.$api.SetTrainEnrollStudentPayStatus({
                    "EnrollIds": ids,
                    "StudentIsPaid": isPayFee
                }).then(data=>{
                    if(data.Code == 0){
                        this.$message.success(`批量设置“${isPayFee ? '已缴费' : '未缴费'}”操作成功`);
                        this.$refs.table.clearSelection();
                        ids.forEach(id=>{
                            let index = this.list.findIndex(item=>item.EnrollId == id);
                            if(index >= 0){
                                this.$set(this.list[index], 'StudentIsPaid', isPayFee);
                            }
                        })
                    }
                })
            }
        },
        lookDetail(enrollId){
            this.$refs.studentDialog.show(enrollId);
        },
        auditStatusChange(enrollId){
            let index = this.list.findIndex(item=>item.EnrollId == enrollId);
            if(index > -1){
                this.$api.GetOneTrainEnrollStudentAuditListInfo({
                    "EnrollId": enrollId
                }).then(data=>{
                    if(data.Code == 0 && data.AuditInfo){
                        this.$set(this.list, index, data.AuditInfo);
                    }
                })
            }
        },
        payStatusChange(enrollId, isPayFee){
            let index = this.list.findIndex(item=>item.EnrollId == enrollId);
            if(index >= 0){
                this.$set(this.list[index], 'StudentIsPaid', isPayFee);
            }
        }
    }
};
</script>
<style scoped>
@import "~@/assets/css/clear-el.css";
.el-table{
    border: 1px solid #EBEEF5;
}
.el-table ::v-deep th{
    border-bottom-color: #EBEEF5 !important;
}
.load_more{
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
    box-sizing: border-box;
    cursor: pointer;
}
.load_more:hover{
    color: #409EFF;
}
</style>